// Vue:
import Vue from 'vue';

// Vue mixins:
import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

// Vue directives:

// Vue components:
import { ssoFiltreraDatatable } from 'v-components/ssoFiltreraDatatable';
import { ssoTogglaRaderIDatatable } from 'v-components/ssoTogglaRaderIDatatable';
import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';
import euiMermeny from 'v-components/euiMermeny';

// Vue store:
import { ssoStatestore as store } from 'v-store/ssoStatestore';	// 'store' för jag vet inte om/hur jag kan använda ett annat namn nedan :(

// Övrigt:
import { ssoTooltips } from 'ssoTooltips';
import { ssoForteckningDatatable } from 'datatables/ssoForteckningDatatable';
import SetOrUpdateClassOnFirstAndLastNonHiddenChild from 'SetOrUpdateClassOnFirstAndLastNonHiddenChild';
import addPageAsWidget from 'ssoAddPageAsWidget';

//------------------------------------------------------------------------------------------------------------------------------

// Använd dessa Vue plugins:
Vue.use(ssoFiltreraDatatable);
Vue.use(ssoTogglaRaderIDatatable);

window.ssoAllaSidor = window.ssoAllaSidor || {};	// För att undvika ESLint-varningar att den är odefinierad.
window.ssoForteckning = window.ssoForteckning || {};	// För att undvika ESLint-varningar att den är odefinierad.

// Fixa till sidans mermeny, så den är av rätt class type:
window.ssoForteckning.sidansMermenyConfig =
	euiPopUpMenyClasses.menyConfig.castFrom(window.ssoForteckning.sidansMermenyConfig, { castAlsoNestedObjectsAndArrayValues: true });		// "casta" till rätt typ, inkl alla nästade underobjekt/arrayvärden.


// Todo: Temp.. *kanske*!
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.performance = process.env.NODE_ENV !== 'production';	// Inspekterbart i web tools flik Performance.


//##############################################################################################################################

//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	store,	// ssoStatestore

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Lokalt registrarade komponenter
	components: {
		euiMermeny,
	},

	// Data utöver de från mixin ovan:
	data: {
		// Ytterligare data finns i ssoStateStore!

		// Reaktiva data:

		sidansMermenyConfig: window.ssoForteckning.sidansMermenyConfig,		// Obs! Denna är tillfixad FÖRE Vue-appen initieras (räcker inte i beforeCreate!)

		tabellen: null,		// Initialt så. null betyder 'ännu inte satt'

		hovrarFotnot1: false,	// Initialt så.

		bortbokadeInaktiverad: window.ssoForteckning.bortbokadeInaktiverad,

		// Obs! Nedan: inte reaktiva (read-only) data, medelst användningen av Object.freeze():

		kontonr: Object.freeze(window.ssoForteckning.kontonr),
	},

	computed: {

		// computed property functions cannot be arrow functions, because this will be undefined in arrow functions. (The same is true for methods, watches and all lifecycle hooks, btw).

		bortbokadeVisas: {
			// getter
			get() {
				return this.$store.state.forteckning.bortbokadeVisas;
			},
			// setter
			set(value) {
				this.$store.commit('forteckning/setBortbokadeVisas', value);
			}
		}
	},

	watch: {
		bortbokadeVisas(nyttVarde, tidigareVarde) {
			SetOrUpdateClassOnFirstAndLastNonHiddenChild('#_ss-tabellen_kropp tbody');

			if (nyttVarde) {
				// Nya rader ska visas och har därmed lagts till i tabellen:
				// Tooltips måste bindas om:
				ssoTooltips.ominitiera();
			}
		}
	},

	methods: {

		onTogglingAvBortbokade(skaVisas) {
			// Vid klick/toggling på någon av de "generiska kryssrutorna" på sidan:
			// Detta behövs för att "kryssrutorna" äter upp klick/toggling och då släcks inte eventuella synliga tooltips:
			ssoTooltips.doljAlla();

			// Ytterligare åtgärder finns i 'watch:'!
		},

		onMenyalternativValt({ eventId, eventData }) {
			switch (eventId) {
				case 'addPageAsWidget': 
					{
						console.log('addPageAsWidget', eventId, eventData);

						const toPageId = eventData;		// Enkom för tydlighet.

						addPageAsWidget(this, {
							toPageId: toPageId,
							elementName: 'forteckningwidget',
							parameters: this.kontonr,
							settings: ''
						});

						break;
					}
			}
		},
	},


	//== Lifecycle hooks  ================================================================================================================

	beforeCreate() {
		// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.

		// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
		// Dessa används för att styra funktionalitet i mixin "ssoAllaSidorMixin":
		// Defaultvärde sätts numera i mixinen: this.$_rullningsbaraElementQuerySelectorAll = '.-rullningsbar-auto, .-rullningsbar-overlay, .-rullningsbar-auto-persist, .-rullningsbar-overlay-persist';
		this.$_vuexNamespace = 'forteckning';
	},

	mounted() {
		// Note that mounted does not guarantee that all child components have also been mounted.

		console.time('#TIMING: initieraDataTable');	// Todo: TEMP!!!
		this.tabellen = ssoForteckningDatatable.initiera(window.ssoForteckning.dataSet);
		console.timeEnd('#TIMING: initieraDataTable');	// Todo: TEMP!!!

		SetOrUpdateClassOnFirstAndLastNonHiddenChild('#_ss-tabellen_kropp tbody');

		//this.$nextTick(function ()
		//{
		//	// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
		//	// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:
		//})
	}
});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;
